export default __webpack_public_path__ + "bb2b21772287c21fa88f8ac1a1181161.png";